// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605210727/js/" + chunkId + "." + {"44":"5438ecd5","225":"20abb758","481":"65e97971","486":"f8eefc06","770":"fe2f8bba"}[chunkId] + ".0.9524613977776666.chunk.js";
};